import { I18nLocalesEnum } from '@zaoblako/shared/common/enums/i18n.locales.enum';
import { RoleEnum } from '@zaoblako/shared/modules/security/enums/role.enum';

/**
 * Localised display names for {@link RoleEnum} enumeration values
 * grouped by locales ({@link I18nLocalesEnum} values)
 */
export const RoleEnumI18n: Record<I18nLocalesEnum, Record<RoleEnum, string>> = {
  [I18nLocalesEnum.EN_US]: {
    [RoleEnum.ROLE_ADMIN]: 'Administrator',
    [RoleEnum.ROLE_USER]: 'User',
    [RoleEnum.ROLE_ACCOUNTANT]: 'Accountant',
    [RoleEnum.ROLE_TREASURER]: 'Treasurer',
    [RoleEnum.ROLE_BRS]: 'BRS user',
    [RoleEnum.ROLE_DIRECTOR]: 'Director',
    [RoleEnum.ROLE_1C_BOT]: '1C ERP Bot',
    [RoleEnum.ROLE_BUGTRACKER_BOT]: 'Bug tracking system bot',
    [RoleEnum.ROLE_MEGAPLAN_BOT]: 'Megaplan Bot',
    [RoleEnum.ROLE_AMOCRM_BOT]: 'amoCRM Bot',
    [RoleEnum.ROLE_HELPDESK_BOT]: 'HelpDesk Bot',
  },
  [I18nLocalesEnum.RU_RU]: {
    [RoleEnum.ROLE_ADMIN]: 'Администратор',
    [RoleEnum.ROLE_USER]: 'Пользователь',
    [RoleEnum.ROLE_ACCOUNTANT]: 'Бухгалтер',
    [RoleEnum.ROLE_TREASURER]: 'Казначей',
    [RoleEnum.ROLE_BRS]: 'Пользователь системы платежей',
    [RoleEnum.ROLE_DIRECTOR]: 'Директор',
    [RoleEnum.ROLE_1C_BOT]: 'Бот 1С',
    [RoleEnum.ROLE_BUGTRACKER_BOT]: 'Бот системы отслеживания ошибок',
    [RoleEnum.ROLE_MEGAPLAN_BOT]: 'Бот МегаПлан',
    [RoleEnum.ROLE_AMOCRM_BOT]: 'Бот amoCRM',
    [RoleEnum.ROLE_HELPDESK_BOT]: 'Бот HelpDesk',
  },
};
